import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button, Badge } from "reactstrap";
import axios from "axios";
import Header from "../../layout/Header/Header";

function BotonesAdmin() {
  const { user } = useContext(AuthContext);
  const [devolucionesPendientes, setDevolucionesPendientes] = useState(0);

  useEffect(() => {
    const URL = process.env.REACT_APP_URL_DEVOLUCIONES;
    if (!URL) return;
    axios
      .get(URL, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const pendientes = (res.data || []).filter(
          (d) => d.is_active === "Si" && d.aplicada === "No"
        );
        setDevolucionesPendientes(pendientes.length);
      })
      .catch(() => setDevolucionesPendientes(0));
  }, []);

  const Btn = ({ permitido, href, icon, label, badge }) => (
    <Col md={4} align="center">
      {permitido ? (
        <Button href={href} className="botonesMenu" color="success" style={{ position: "relative" }}>
          {badge != null && badge > 0 && (
            <Badge color="danger" style={{ position: "absolute", top: 8, right: 8, fontSize: 14 }}>
              {badge}
            </Badge>
          )}
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      ) : (
        <Button disabled className="botonesMenu" color="success">
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      )}
    </Col>
  );

  const Seccion = ({ titulo }) => (
    <>
      <br />
      <h4
        style={{
          borderBottom: "2px solid #f28029",
          paddingBottom: 6,
          marginBottom: 16,
          color: "#333",
        }}
      >
        {titulo}
      </h4>
    </>
  );

  return (
    <>
      <Header />
      {user.configAdmin ? (
        <div className="container">
          <br />

          {/* ===== VENTAS ===== */}
          {/* <Seccion titulo="Ventas" /> */}
          {/* <Row> */}
            {/* <Btn permitido={user.menu_ventas} href="/ListadoVentas" icon="fa-money-bill-wave" label="Ventas" /> */}
            {/* <Btn permitido={user.menu_ventas} href="/ListadoVentasNoEvidencia" icon="fa-ban" label="Ventas Sin Evidencia" /> */}
          {/* </Row> */}

          {/* ===== COBRANZA ===== */}
          <Seccion titulo="Cobranza" />
          <Row>
            <Btn permitido={user.abonos} href="/ListadoAbonos" icon="fa-dollar-sign" label="Abonos" />
            {/* <Btn permitido={user.abonos} href="/ListadoAbonosAgrupado" icon="fa-dollar-sign" label="Abonos Agrupado" /> */}
            <Btn permitido={user.menuAnticipos} href="/ListadoAnticipos" icon="fa-hand-holding-usd" label="Anticipos" />
            <Btn permitido={user.menu_devolucionesAdmin} href="/ListadoDevolucionesAdmin" icon="fa-undo-alt" label="Aplicar Dev" badge={devolucionesPendientes} />
          </Row>
          <br />
          <Row>
            <Btn permitido={user.abonos} href="/ReporteAbonosCompPago" icon="fa-file-invoice-dollar" label="Reporte Abonos" />
          </Row>

          {/* ===== CUENTAS ===== */}
          {/* <Seccion titulo="Cuentas" />
          <Row>
            <Btn permitido={user.edoCtaClientes} href="/EstadoCuenta" icon="fa-file-invoice-dollar" label="Estado Cuenta" />
            <Btn permitido={user.abonos} href="/AntiguedadSaldosVencido" icon="fa-dollar-sign" label="Antiguedad Saldos" />
            <Btn permitido={user.abonos} href="/CobranzaVendedor" icon="fa-hand-holding-usd" label="Cobranza Vendedor" />
          </Row> */}

          {/* ===== TESORERÍA ===== */}
          <Seccion titulo="Tesorería" />
          <Row>
            <Btn permitido={user.bancos} href="/Bancos" icon="fa-university" label="Bancos" />
            <Btn permitido={user.bancos} href="/MovimientosBancos" icon="fa-list-ol" label="Movimientos Bancos" />
            {/* <Btn permitido={user.gastosTiendas} href="/ListadoTraspasosDinero" icon="fa-dollar-sign" label="Traspaso Dinero" /> */}
          </Row>

          {/* ===== COMISIONES ===== */}
          <Seccion titulo="Comisiones" />
          <Row>
            <Btn permitido={user.comisiones} href="/ListadoComisiones" icon="fa-percentage" label="Comisiones" />
            <Btn permitido={user.comisiones} href="/ControlViaticos" icon="fa-wallet" label={<>Control<br />Viáticos</>} />
            <Btn permitido={user.estado_cuenta_vendedores} href="/EstadoCuentaVendedores" icon="fa-list-ul" label={<>Estado Cuenta<br />Vendedores</>} />
          </Row>

          {/* ===== REPORTES ===== */}
          {/* <Seccion titulo="Reportes" />
          <Row>
          </Row> */}

          {/* ===== CATÁLOGOS ===== */}
          <Seccion titulo="Catálogos" />
          <Row>
            <Btn permitido={user.bancos} href="/Empresas" icon="fa-industry" label="Empresas" />
          </Row>

          <br />
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesAdmin;
